<template>
  <div :style="{ backgroundColor: projectIconsData.backgroundColor }" class="customer-icons">
      <h1 :style="{ color: projectIconsData.iconsTitleColor }" class="icons-title">ICONS</h1>
    <img :src="projectIconsData.iconsImage" class="icons-image">
  </div>
</template>
<script>
  export default {
    name: 'CustomerIcons',
    props: {
      projectIconsData: {
        backgroundColor: String,
        iconsTitleColor: String,
        iconsImage : String
      }
    },
  }
</script>
<style lang="scss" scoped>
  @import "../../assets/scss/customerIcons.scss";
</style>



// WEBPACK FOOTER //
// src/pages/CustomersComponents/CustomerIcons.vue